export const downloadAudio = (audioUri: string, filename: string) => {
  const link = document.createElement('a')
  link.href = audioUri
  link.setAttribute('download', filename)
  document.body.appendChild(link)
  link.click()
  document.body.removeChild(link)
}
